// extracted by mini-css-extract-plugin
module.exports = {"groupList":"_2mlKefZ9_-UfQBpxGAxWO0","groupName":"rCmwNnBUSRUm9RaglGO3I"};